var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88833 5.07993C13.1685 4.45059 17.5467 4.12476 22.0002 4.12476C26.4532 4.12476 30.8311 4.45053 35.1109 5.07976C38.7379 5.613 41.2497 8.78958 41.2497 12.3574V23.3921C41.2497 26.96 38.7379 30.1365 35.1109 30.6698C33.0096 30.9787 30.8847 31.2145 28.7388 31.3745C28.5106 31.3915 28.3119 31.5101 28.1946 31.6862L23.1437 39.2625C22.8887 39.645 22.4594 39.8748 21.9997 39.8748C21.5399 39.8748 21.1106 39.645 20.8556 39.2625L15.8047 31.6861C15.6873 31.51 15.4886 31.3914 15.2605 31.3744C13.1146 31.2143 10.9896 30.9785 8.88832 30.6696C5.2614 30.1363 2.74966 26.9597 2.74966 23.3919V12.3576C2.74966 8.78976 5.26141 5.61321 8.88833 5.07993ZM12.3747 15.1248C12.3747 14.3654 12.9903 13.7498 13.7497 13.7498H30.2497C31.0091 13.7498 31.6247 14.3654 31.6247 15.1248C31.6247 15.8841 31.0091 16.4998 30.2497 16.4998H13.7497C12.9903 16.4998 12.3747 15.8841 12.3747 15.1248ZM13.7497 19.2498C12.9903 19.2498 12.3747 19.8654 12.3747 20.6248C12.3747 21.3841 12.9903 21.9998 13.7497 21.9998H21.9997C22.7591 21.9998 23.3747 21.3841 23.3747 20.6248C23.3747 19.8654 22.7591 19.2498 21.9997 19.2498H13.7497Z",
    fill: "#010304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityChat);
export default __webpack_public_path__ + "static/media/community_chat.52fc668959896b0f7bdbf1bc9bdfd839.svg";
export { ForwardRef as ReactComponent };